/* Open Road Gallery — dependency-free lightbox.
 * Binds to [data-or-gallery-item] inside [data-or-gallery] roots.
 * Clicking an item opens its [data-or-src] image full-screen. */
(function () {
  function init(root) {
    var items = root.querySelectorAll('[data-or-gallery-item]');
    if (!items.length) return;

    var box = document.createElement('div');
    box.className = 'or-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<button class="or-lightbox__close" type="button" aria-label="Close">×</button>' +
      '<img class="or-lightbox__img" alt="">';
    document.body.appendChild(box);

    var img = box.querySelector('.or-lightbox__img');

    function open(src) {
      img.src = src;
      box.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      box.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
    }

    items.forEach(function (el) {
      el.addEventListener('click', function (e) {
        var src = el.getAttribute('data-or-src');
        if (src) {
          e.preventDefault();
          open(src);
        }
      });
    });

    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('or-lightbox__close')) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-or-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init in the Shopify theme editor when a section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-or-gallery]');
    if (root) init(root);
  });
})();
